import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from '../AssignmentsTable.module.scss';

const AssignmentFilterButton = ({
  active, buttonText, handleToggle, iconStyles, value
}) => {
  const toggleState = value;
  const [disabled, setDisabled] = useState(false);
  const buttonID = `assignment-filter-button-${value}`;

  const onToggle = () => {
    if (active) return;
    handleToggle(null, toggleState);
    setDisabled(true);
    setTimeout(() => setDisabled(false), 800);
  };

  return (
    <div className={styles.toggleWrapper}>
      <button
        aria-pressed={active}
        className={`btn btn--card ${active ? styles.active : ''} ${styles.studentAssignmentToggle}`}
        disabled={disabled}
        id={buttonID}
        type="button"
        onClick={onToggle}
      >
        <i className={iconStyles} />&nbsp;
        {buttonText}
      </button>
    </div>
  );
};

AssignmentFilterButton.propTypes = {
  active: PropTypes.bool.isRequired,
  buttonText: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,
  iconStyles: PropTypes.string,
  value: PropTypes.string.isRequired,
};

export default AssignmentFilterButton;
